import React from 'react';
import { Margin, P } from '@ovotech/element-v4';
import { ModalStepTitle } from '@/src/pages/AnytimeEligibilityV2/pages/PreEligibilityProducts/PreEligibilityProducts.styled';

export const WhatYouGetStep4: React.FC = () => (
  <Margin top={6}>
    <ModalStepTitle>ClearWatt EV battery health check</ModalStepTitle>
    <Margin bottom={6}>
      <P>
        Check the performance of your EV and the battery condition. Free with
        1000+ miles plans.{' '}
      </P>
    </Margin>
    <ModalStepTitle>15% Kwik Fit Club discount</ModalStepTitle>
    <Margin bottom={4}>
      <P>
        Enjoy peace of mind with money off Kwik Fit Club, a monthly subscription
        service that includes repairs, tyre replacements and MOT. Free with
        1000+ miles plans.
      </P>
    </Margin>
  </Margin>
);
